<!DOCTYPE html>
<html>

<head>
    <script type="text/javascript">
        window.history.forward();
        function noBack() {
            window.history.forward();
        }
    </script>
</head>

<body>
    <div>
        <div id="spinner">
            <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="#067ea1" type="ball-spin-clockwise-fade"
                [fullScreen]="false">
                <p class="mt-5" style="color: #067ea1"> Loading... </p>
            </ngx-spinner>

        </div>
        <div>
            <router-outlet></router-outlet>
        </div>
    </div>
</body>

</html>